import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useCatalogLoggingContext } from '@apps/registry/common/components/Catalog/Catalog.logging';
import type { HeroDataProps } from '../../../../CatalogProductsIndex/components/ShopHeroSlider/components/Hero';

export const useCatalogCurationHeroTelemetry = (curations: HeroDataProps[]) => {
  const { watchCurationVideoClicked, curationsHeroSectionExploreCurationClicked, getProductCatalogCategoryBasePageEventProps } = useCatalogLoggingContext();

  const getCurationById = useEventCallback((curationId: string) => {
    return curations.find(curation => curation.id === curationId);
  });

  const trackExploreCurationClicked = useEventCallback((curationId: string, method: 'curationsHeroSection' | 'videoPlayer', isVideoPlaying: boolean) => {
    const targetCuration = getCurationById(curationId);
    curationsHeroSectionExploreCurationClicked({
      curationId,
      curationTitle: targetCuration ? targetCuration.title : '<CURATION NOT FOUND>',
      method,
      isVideoPlaying,
      ...getProductCatalogCategoryBasePageEventProps({ product: null, curation: { id: targetCuration?.id ?? '', publicUrlPath: targetCuration?.cta.publicUrlPath ?? '' } })
        .categoryTelemArgs,
    });
  });

  const trackBillboardWatchCurationVideoCtaClick = useEventCallback((curationId: string) => {
    const targetCuration = getCurationById(curationId);
    watchCurationVideoClicked({
      curationId,
      curationTitle: targetCuration ? targetCuration.title : '<CURATION NOT FOUND>',
      page: 'root',
      method: 'ctaButton',
    });
  });

  return {
    trackExploreCurationClicked,
    trackBillboardWatchCurationVideoCtaClick,
  };
};
